import { createFileRoute, redirect } from '@tanstack/react-router';
import { getPreferredLocale } from '@shared/config/i18n';

/**
 * Root Index Route
 *
 * Redirects "/" to "/{locale}/" using the stored user preference (fallback: en).
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const locale = getPreferredLocale();
    // TanStack Router requires throwing redirect object
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/$locale', params: { locale } });
  },
});
